import { Component, Input } from '@angular/core';

@Component({
  selector: 'company-stats-bar',
  templateUrl: 'company-stats-bar.html'
})
export class CompanyStatsBarComponent {
  @Input() company: any = {};
  @Input() componentsOfValue: any = {};
  @Input() currencyUnit: any = {};
  @Input() flexedData: any = {};
  @Input() flexed: boolean = false;
  flexedLabel = '';
  yearThree: number;
  impliedOverYearThree: number;
  ebitMarginExpectation: number;

  ngOnInit() {
    this.ebitMarginExpectation = this.company.platformData.ebitMarginExpectation;
    this.yearThree = this.company.platformData.ebitMarginData.yearThree;
    this.impliedOverYearThree = this.company.platformData.ebitMarginExpectation/this.yearThree;
  }
  ngOnChanges() {
    this.flexedLabel = (this.flexed) ? 'Flexed ' : '';
    if (!this.flexedData.valueDrivers) return;
    this.yearThree = (this.flexed) ? this.flexedData.valueDrivers.ebitMargin[2].value : this.company.platformData.ebitMarginData.yearThree;
    this.ebitMarginExpectation = (this.flexed) ? this.flexedData.ebitMarginExpectation : this.company.platformData.ebitMarginExpectation
    this.impliedOverYearThree = (this.flexed) ? this.ebitMarginExpectation/this.yearThree : this.ebitMarginExpectation/this.yearThree;

  }

}



// WEBPACK FOOTER //
// ./src/components/company-stats-bar/company-stats-bar.ts